import React from 'react';
import styles from '../OrderStatus.module.css';
import { config } from '../../../utils/config';

const OrderDetails = (props) => {

  function getStatusDescription() {

    const frp_phone = config('frp_phone');

    switch (props.order.purchase_status) {
      case 'order received':
        return 'We have received this order but have not yet started processing it.';
      case 'card declined':
        return 'There was a problem processing the credit card used on the order. This is often due simply to mis-keyed information at checkout time. Please give us a call at ' + frp_phone + ' so we can correct the issue and ship your parts to you.';
      case 'approval pending':
        if (props.order.purchase_ship_code == 'WC') {
          return 'This will call order is in stock and waiting for you to come pick it up.';
        } else {
          return 'If you are a member of a multiple user account, this could mean that a supervisor must approve the order before we can process it. If you are not a member of a multiple user account, there might be a problem with your order and you should give us a call at ' + frp_phone + '.';
        }
      case 'approval pending - response needed':
        return 'Your order is currently on hold and we need you to contact us before we can process your order further. Please give us a call at ' + frp_phone + '.';
      case 'processing':
        return 'We have received your order and are processing your order for shipment.';
      case 'PO to vendor':
        return 'Part or all of your order has been ordered from one of our vendors.';
      case 'Back Ordered':
        return 'Our vendor is currently back ordered on one or all of the parts on your order.';
      case 'shipped':
        if (props.order.purchase_ship_code == 'WC') {
          return 'Your order has been picked up.';
        } else {
          return 'Your order has been shipped to you.';
        }
      case 'cancelled':
        return 'Either you called and cancelled your order, or there was a problem with your order causing us to cancel it.';
    }
  }

  return (
    <>
      <h2 className={styles.heading}>ORDER STATUS</h2>
      <table style={{ marginBottom: 10 }}>
        <tbody>
          <tr>
            <td className={styles.detailTitle}>Ordered:</td>
            <td className={styles.detail}>{props.order.purchase_date}</td>
          </tr>
          <tr>
            <td className={styles.detailTitle}>Status:</td>
            <td className={styles.detail}><strong>{props.order.purchase_status}</strong></td>
          </tr>
          <tr>
            <td className={styles.detailTitle}>Description:</td>
            <td className={styles.detail}>{getStatusDescription()}</td>
          </tr>
        </tbody>
      </table>
    </>
  );
};

export default OrderDetails;